module.exports = __webpack_public_path__ + "img/cluster-visitorslocations.305cb74d.png";